import styled, { css } from "styled-components";

export interface IJackpotWidgetFooterBoxProps {
	forcePCView?: boolean;
	widgetIsMinimized?: boolean;
};

export const JackpotWidgetFooterBox = styled.div<IJackpotWidgetFooterBoxProps>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2rem;

	${({forcePCView}) => !forcePCView && css`
		@media ${({theme}) => theme.mediaQuery.mAndBelow} {
	        flex-direction: column;
	        padding: 0rem 0rem 1rem;
	    }
	`}

	${({widgetIsMinimized}) => widgetIsMinimized && css`
		flex-direction: column;
		justify-content: center;
		width: 35%;
		padding: 0 1rem 0 0;
	`}

`;
